import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  CANCEL,
  CLOSE,
  MESSAGEUS
} from '../../models/constants/error-modal-constants';
import { ActionButton, ErrorModalInfo } from '../../..';

@Component({
  selector: 'idp-ineligibility-modal',
  templateUrl: './ineligibility-modal.component.html',
  styleUrls: ['./ineligibility-modal.component.scss']
})
export class IneligibilityModalComponent implements OnInit {
  @Input() content!: ErrorModalInfo;
  modalOpen = false;

  @Output() closeModalAction = new EventEmitter<boolean>();
  @Output() cancelEvent = new EventEmitter<string>();
  @Output() messageUsEvent = new EventEmitter<string>();

  ngOnInit(): void {
    this.modalOpen = true;
  }

  closeModal(): void {
    this.modalOpen = false;
    this.closeModalAction.emit(true);
  }

  handleModalAction(action: ActionButton): void {
    if (action.action === CLOSE) {
      this.closeModal();
    } else if (action.action === CANCEL) {
      this.cancelEvent.emit(action.link);
    } else if (action.action === MESSAGEUS) {
      this.messageUsEvent.emit(action.link);
      this.closeModal();
    }
  }
}
